export default "__VITE_ASSET__Cegy0Oh9__"